import { Button, Typography } from '@breetometer/components';

const RequestNewPassword = () => (
	<div className='newpasswordrequest'>
		<Typography
			as='h1'
			variant='big_header'
		>
			Token Expired
		</Typography>
		<Typography as='p'>Kindly request a new password reset link.</Typography>
		<Button
			label='Request New Link'
			variant='tertiary'
		/>
	</div>
);

export default RequestNewPassword;
